module.exports = __webpack_public_path__ + "static/img/20.d208c3f5.png";